export const medicalHistoryTableHeaders = [
  "date",
  "condition",
  "consultationType",
  "View",
];

export const posAllCategoryList = [
  "deworming",
  "flea & tick treatment",
  "other parasite treatment",
  "medication",
  "fluid therapy",
  "diet",
  "nutrition & supplements",
  "otc products",
  "grooming & hygiene care",
  "accessories & toys",
  "pet supplies",
];

export const posPharmacyCategoryList = [
  "deworming",
  "flea & tick treatment",
  "other parasite treatment",
  "medication",
  "fluid therapy",
  "diet",
  "nutrition & supplements",
  "grooming & hygiene care",
];

export const posPetShopCategoryList = [
  "otc products",
  "grooming & hygiene care",
  "accessories & toys",
  "pet supplies",
];

export const billingPharmacyCategoryList = [
  "general consumables",
  "medical supplies",
  "surgical supplies",
  "lab consumables",
  "lab supplies",
  "cleaning supplies",
  "grooming & hygiene care",
  "fluid therapy",
  "mortuary",
  "deworming",
  "diet",
  "flea & tick treatment",
  "medication",
  "nutrition and supplements",
  "other parasite treatment",
  "vaccines",
];
